import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, EditIcon, MailIcon, PhoneIcon, MapPinIcon, PackageIcon, CalendarIcon, TrendingUpIcon } from 'lucide-react';
export function SupplierDetail() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  // Mock data
  const supplier = {
    id: id,
    companyName: 'Premium Tea Estates Ltd',
    contactPerson: 'Rajesh Kumar',
    email: 'rajesh@premiumtea.lk',
    phone: '+60 12 345 6789',
    address: '123 Tea Estate Road, Nuwara Eliya, Sri Lanka',
    productsSupplied: 'Ceylon Black Tea, Green Tea, White Tea',
    paymentTerms: 'Net 30',
    status: 'Active',
    totalOrders: 45,
    totalValue: 'RM 2,450,000',
    lastOrderDate: '2024-01-15',
    createdDate: '2023-06-10'
  };
  const recentOrders = [{
    id: 'PO-001',
    date: '2024-01-15',
    items: 'Ceylon Black Tea (500kg)',
    amount: 'RM 125,000',
    status: 'Delivered'
  }, {
    id: 'PO-002',
    date: '2024-01-08',
    items: 'Green Tea (300kg)',
    amount: 'RM 90,000',
    status: 'Delivered'
  }, {
    id: 'PO-003',
    date: '2023-12-28',
    items: 'White Tea (200kg)',
    amount: 'RM 150,000',
    status: 'Delivered'
  }];
  return <div className="space-y-6" data-id="element-9041">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-9042">
        <div className="flex items-center space-x-4" data-id="element-9043">
          <button onClick={() => navigate('/suppliers')} className="p-2 hover:bg-gray-100 rounded-md" data-id="element-9044">
            <ArrowLeftIcon size={20} data-id="element-9045" />
          </button>
          <div data-id="element-9046">
            <h2 className="text-2xl font-semibold text-gray-900" data-id="element-9047">
              {supplier.companyName}
            </h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-9048">Supplier Details</p>
          </div>
        </div>
        <button onClick={() => navigate(`/supplier-form?id=${id}`)} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-9049">
          <EditIcon size={18} className="mr-2" data-id="element-9050" />
          Edit Supplier
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-9051">
        {/* Left Column - Supplier Info */}
        <div className="lg:col-span-2 space-y-6" data-id="element-9052">
          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-9053">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-9054">
              Contact Information
            </h3>
            <div className="space-y-4" data-id="element-9055">
              <div className="flex items-start" data-id="element-9056">
                <MailIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-9057" />
                <div data-id="element-9058">
                  <p className="text-sm text-gray-500" data-id="element-9059">Email</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-9060">
                    {supplier.email}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-9061">
                <PhoneIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-9062" />
                <div data-id="element-9063">
                  <p className="text-sm text-gray-500" data-id="element-9064">Phone</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-9065">
                    {supplier.phone}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-9066">
                <MapPinIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-9067" />
                <div data-id="element-9068">
                  <p className="text-sm text-gray-500" data-id="element-9069">Address</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-9070">
                    {supplier.address}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-9071">
                <PackageIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-9072" />
                <div data-id="element-9073">
                  <p className="text-sm text-gray-500" data-id="element-9074">Products Supplied</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-9075">
                    {supplier.productsSupplied}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Recent Orders */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-9076">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-9077">
              Recent Orders
            </h3>
            <div className="space-y-3" data-id="element-9078">
              {recentOrders.map(order => <div key={order.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-md hover:bg-gray-50" data-id="element-9079">
                  <div className="flex-1" data-id="element-9080">
                    <div className="flex items-center space-x-3" data-id="element-9081">
                      <p className="text-sm font-medium text-gray-900" data-id="element-9082">
                        {order.id}
                      </p>
                      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${order.status === 'Delivered' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-9083">
                        {order.status}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-9084">{order.items}</p>
                    <p className="text-xs text-gray-400 mt-1" data-id="element-9085">{order.date}</p>
                  </div>
                  <p className="text-sm font-medium text-gray-900" data-id="element-9086">
                    {order.amount}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
        {/* Right Column - Stats */}
        <div className="space-y-6" data-id="element-9087">
          {/* Status */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-9088">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-9089">Status</h3>
            <span className={`px-3 py-1 inline-flex text-sm font-semibold rounded-full ${supplier.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-9090">
              {supplier.status}
            </span>
          </div>
          {/* Statistics */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-9091">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-9092">
              Statistics
            </h3>
            <div className="space-y-4" data-id="element-9093">
              <div data-id="element-9094">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-9095">
                  <TrendingUpIcon size={16} className="mr-2" data-id="element-9096" />
                  Total Orders
                </div>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-9097">
                  {supplier.totalOrders}
                </p>
              </div>
              <div data-id="element-9098">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-9099">
                  <TrendingUpIcon size={16} className="mr-2" data-id="element-9100" />
                  Total Value
                </div>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-9101">
                  {supplier.totalValue}
                </p>
              </div>
              <div data-id="element-9102">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-9103">
                  <CalendarIcon size={16} className="mr-2" data-id="element-9104" />
                  Last Order
                </div>
                <p className="text-sm font-medium text-gray-900" data-id="element-9105">
                  {supplier.lastOrderDate}
                </p>
              </div>
              <div data-id="element-9106">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-9107">
                  <CalendarIcon size={16} className="mr-2" data-id="element-9108" />
                  Member Since
                </div>
                <p className="text-sm font-medium text-gray-900" data-id="element-9109">
                  {supplier.createdDate}
                </p>
              </div>
            </div>
          </div>
          {/* Payment Terms */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-9110">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-9111">
              Payment Terms
            </h3>
            <p className="text-sm text-gray-900" data-id="element-9112">{supplier.paymentTerms}</p>
          </div>
        </div>
      </div>
    </div>;
}